import { render, staticRenderFns } from "./PointManage.vue?vue&type=template&id=97bb41ac&scoped=true&"
import script from "./PointManage.vue?vue&type=script&lang=js&"
export * from "./PointManage.vue?vue&type=script&lang=js&"
import style0 from "./PointManage.vue?vue&type=style&index=0&id=97bb41ac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bb41ac",
  null
  
)

export default component.exports